export default "__VITE_ASSET__705a16be__"